module.exports = __webpack_public_path__ + "static/assets/9fd052aaf1b4701ff0134d124d6327a3.jpg";